import { ReactNode, useMemo } from 'react';
import { IntlProvider } from 'react-intl';

import { defaultLang } from 'config';

import enMessages from 'i18n/compiled-lang/en.json';
import itMessages from 'i18n/compiled-lang/it.json';
import { useGlobalSelector } from 'stores';
import { Locales } from 'types/intl';

const CustomIntlProvider = ({ children }: { children: ReactNode }) => {
  const { activeLocale } = useGlobalSelector();

  const messages = useMemo(() => {
    switch (activeLocale) {
      case Locales.EN:
        return enMessages;
      case Locales.IT:
        return itMessages;
      default:
        return enMessages;
    }
  }, [activeLocale]);

  return (
    <IntlProvider
      locale={activeLocale}
      defaultLocale={defaultLang.value}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};

export { CustomIntlProvider };
